import API from './api';
import { toError } from './apiError';

const api = new API();

const URL = 'api/organizations/impersonate';

const LOAD_ERROR = 'Failed to load the account list';
const IMPERSONATE_ERROR = 'Failed to switch account';

const loadListeners = new Set();

export function onOrganizationsLoaded(listener) {
    loadListeners.add(listener);
    return () => loadListeners.delete(listener);
}

function notifyLoaded(organizations) {
    loadListeners.forEach(listener => listener(organizations));
    return organizations;
}

function fetchOrganizations() {
    return api
        .getJson(URL, { method: 'GET' })
        .then(response => {
            if (!response || response.status !== 0) {
                throw toError(response && response.value, LOAD_ERROR);
            }
            return (response.value && response.value.organizations) || [];
        })
        .catch(reason => {
            throw toError(reason, LOAD_ERROR);
        })
        .then(notifyLoaded);
}

let listPromise = null;

export function getOrganizations() {
    if (!listPromise) {
        listPromise = fetchOrganizations().catch(error => {
            listPromise = null;
            throw error;
        });
    }
    return listPromise;
}

export function invalidateOrganizations() {
    listPromise = null;
}

export function impersonateOrg(orgId) {
    return api
        .getJson(URL, { method: 'POST', body: { org_id: orgId } })
        .then(response => {
            if (!response || response.status !== 0) {
                throw toError(response && response.value, IMPERSONATE_ERROR);
            }
        })
        .catch(reason => {
            throw toError(reason, IMPERSONATE_ERROR);
        });
}
